import React from 'react';

export const TermsAndConditions: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-4xl font-bold mb-6 text-center text-gray-800">Terms and Conditions</h1>
      <p className="text-gray-600 mb-8 text-center">Effective Date: 1st November 2024</p>
      
      <div className="space-y-12">
        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">1. Introduction</h2>
          <p className="text-gray-700 leading-relaxed">
            Welcome to Shynerz Baby Shop. These Terms and Conditions govern how you use our website and services. 
            By accessing or using our website, you agree that you will comply with these terms. However, if you 
            do not agree with them, kindly do not use our site.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">2. Use of the Website</h2>
          <p className="text-gray-700 leading-relaxed">
            You must be at least 18 years old to use our website. By using our website, you warrant us that you 
            meet this age requirement. You therefore agree to use the site only for lawful reasons and in a manner 
            that does not infringe on the rights of other users.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">3. Intellectual Property</h2>
          <p className="text-gray-700 leading-relaxed">
            All content on this website, including text, graphics, logos, and images, is the property of Shynerz 
            Baby Shop or its content suppliers and is protected by copyright laws. You will therefore not reproduce, 
            distribute, or create derivative works from any content without our prior written consent.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">4. User Accounts</h2>
          <p className="text-gray-700 leading-relaxed">
            If you create an account on our website, you are responsible for maintaining your data update, the 
            confidentiality of your account information and for all activities that occur under your account. 
            You will be required to notify us immediately of any unauthorized use of your account.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">Contact Us</h2>
          <p className="text-gray-700 leading-relaxed">
            If you have any questions about these Terms and Conditions, please contact us at:{' '}
            <a href="mailto:sales.shynerz@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
            sales.shynerz@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}; 